import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

//import useRadio from "../Assets/UseRadio";
import useInput from "../Assets/UseInput";
import {useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, InputGroup, Button, InputGroupText, Label, Row} from "reactstrap";
import BreadCrumb from "../Layout/BreadCrumb";


var serialize = require('serialize-javascript');

function JobPartnerEmployee (props) {
    // fetch data from local Storage
    let history = useNavigate();
const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const { i18n } = useTranslation();


    //specific constant if needed
    const [stored, setStored] =  useState("")

    // set control value and name to classic Inputs using the custom Hook useInput
    const {value: Field32Name, bind: bindField32Name, reset: setField32Name} = useInput('')
    const {value: Field3601WageBrut, bind: bindField3601WageBrut, reset: setField3601WageBrut} = useInput('')
    const {value: Field3603WageNet, bind: bindField3603WageNet, reset: setField3603WageNet} = useInput('')
    const {value: Field3602WageImposable, bind: bindField3602WageImposable, reset: setField3602WageImposable} = useInput('')


    const {value: Field33AddressStreet, bind: bindField33AddressStreet, reset: setField33AddressStreet} = useInput('')
    const {value: Field33AddressStreetNumber, bind: bindField33AddressStreetNumber, reset: setField33AddressStreetNumber} = useInput('')
    const {value: Field33AddressStreetBox, bind: bindField33AddressStreetBox, reset: setField33AddressStreetBox} = useInput('')
    const {value: Field33AddressZip, bind: bindField33AddressZip, reset: setField33AddressZip} = useInput('')
    const {value: Field33AddressTown, bind: bindField33AddressTown, reset: setField33AddressTown} = useInput('')
    const {value: Field34RegimeTempsPartielTypeDetail, bind: bindField34RegimeTempsPartielTypeDetail, reset: setField34RegimeTempsPartielTypeDetail} = useInput('')
    const {value: Field35Hours, bind: bindField35Hours, reset: setField35Hours} = useInput('')
    const {value: Field3701AdvantagesDetail, bind: bindField3701AdvantagesDetail, reset: setField3701AdvantagesDetail} = useInput('')



    //errors
    const [Field33AddressStreetError, setField33AddressStreetError]= useState("")
    const [Field33AddressStreetNumberError, setField33AddressStreetNumberError]= useState("")
    const [Field33AddressStreetBoxError, setField33AddressStreetBoxError]= useState("")
    const [Field33AddressZipError, setField33AddressZipError]= useState("")
    const [Field33AddressTownError, setField33AddressTownError]= useState("")
    const [Field33AddressError, setField33AddressError]= useState("")

    const [Field34Regime, setField34Regime] = useState("");
    //  Input radio change
    const handleChangeField34Regime = (e) => {
        let value = e.target.value
        setField34Regime(value);
    }
    const [Field36Wage, setField36Wage] = useState("");
    //  Input radio change
    const handleChangeField36Wage = (e) => {
        let value = e.target.value
        setField36Wage(value);
    }
    const [Field37Advantages, setField37Advantages] = useState("");
    //  Input radio change
    const handleChangeField37Advantages = (e) => {
        let value = e.target.value
        setField37Advantages(value);
    }

    const [Field34RegimeTempsPartielStatut, setField34RegimeTempsPartielStatut] = useState("");
    const handleChangeField34RegimeTempsPartielStatut = (e) => {
        let value = e.target.value
        setField34RegimeTempsPartielStatut(value);
    }
    const [Field34RegimeTempsPartielType, setField34RegimeTempsPartielType] = useState("");
    const handleChangeField34RegimeTempsPartielType = (e) => {
        let value = e.target.value
        setField34RegimeTempsPartielType(value);
    }


    // change multiple cheboxes
    const [Field37AdvantangeCheckbox, setField37AdvantangeCheckbox] = useState({});
    const handleChangeField37AdvantangeCheckbox = (e) => {
        const item = e.target.name;
        const isChecked = e.target.checked;
        let partialChecked = {...Field37AdvantangeCheckbox}
        partialChecked[item] = isChecked
        setField37AdvantangeCheckbox( partialChecked )
        //console.log(Field37AdvantangeCheckbox)
    }


    const [JobPartnerCheckbox, setJobPartnerCheckbox] = useState({});
    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            //dead === "true" ? setDead(true) : setDead(false)
            setDead(true)
            setIsLoading(false);

            const jobPartner = JSON.parse(localStorage.getItem('jobPartner'))

            if (jobPartner){
                setStored(true)
                setJobPartnerCheckbox(jobPartner.PartnerJobCheckbox)
            }

            const jobPartnerEmployee = JSON.parse(localStorage.getItem('jobPartnerEmployee'))

            if (jobPartnerEmployee){
                setStored(true)
                setField32Name(jobPartnerEmployee.Field32Name)
                setField33AddressStreet(jobPartnerEmployee.Field33AddressStreet)
                setField33AddressStreetNumber(jobPartnerEmployee.Field33AddressStreetNumber)
                setField33AddressStreetBox(jobPartnerEmployee.Field33AddressStreetBox)
                setField33AddressTown(jobPartnerEmployee.Field33AddressTown)
                setField33AddressZip(jobPartnerEmployee.Field33AddressZip)
                setField34Regime(jobPartnerEmployee.Field34Regime)
                setField34RegimeTempsPartielStatut(jobPartnerEmployee.Field34RegimeTempsPartielStatut)
                setField34RegimeTempsPartielType(jobPartnerEmployee.Field34RegimeTempsPartielType)
                setField34RegimeTempsPartielTypeDetail(jobPartnerEmployee.Field34RegimeTempsPartielTypeDetail)
                setField35Hours(jobPartnerEmployee.Field35Hours)
                setField36Wage(jobPartnerEmployee.Field36Wage)
                setField3601WageBrut(jobPartnerEmployee.Field3601WageBrut)
                setField3602WageImposable(jobPartnerEmployee.Field3602WageImposable)
                setField3603WageNet(jobPartnerEmployee.Field3603WageNet)
                setField37Advantages(jobPartnerEmployee.Field37Advantages)
                setField37AdvantangeCheckbox(jobPartnerEmployee.Field37AdvantangeCheckbox)
                setField3701AdvantagesDetail(jobPartnerEmployee.Field3701AdvantagesDetail)
            }
        };
        fetchData()
    }, []);

    const next = () =>{
        let nextLocation = {}
        if (!!JobPartnerCheckbox && JobPartnerCheckbox.independant){
            nextLocation = {
                pathname: '../job-partner-independant',
                state: { d: d }
            }
        }else if (!!JobPartnerCheckbox && JobPartnerCheckbox.etudiant){
            nextLocation = {
                pathname: '../job-partner-student',
                state: { d: d }
            }
        }else {
            nextLocation = {
                pathname: '../circumstances',
                state: { d: d }
            }
        }
        history(nextLocation)
    }

    const handleNext = (e) =>{
        e.preventDefault()
        next()
    }

    const prevLocation = {
        pathname: '../information',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }


    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();

        let notValid = ""
        // required empty fields
            notValid = Field32Name === "" || Field33AddressStreet === "" || Field33AddressZip === "" || Field33AddressTown === "" || (!Field3602WageImposable && !Field3601WageBrut && !Field3603WageNet)



        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let jobPartnerEmployee = {
                Field32Name: Field32Name,
                Field33AddressStreet : Field33AddressStreet,
                Field33AddressStreetNumber: Field33AddressStreetNumber,
                Field33AddressStreetBox:Field33AddressStreetBox,
                Field33AddressTown: Field33AddressTown,
                Field33AddressZip: Field33AddressZip,
                Field34Regime:Field34Regime,
                Field34RegimeTempsPartielStatut:Field34RegimeTempsPartielStatut,
                Field34RegimeTempsPartielType:Field34RegimeTempsPartielType,
                Field34RegimeTempsPartielTypeDetail:Field34RegimeTempsPartielTypeDetail,
                Field35Hours: Field35Hours,
                Field36Wage:Field36Wage,
                Field3601WageBrut:Field3601WageBrut,
                Field3602WageImposable:Field3602WageImposable,
                Field3603WageNet:Field3603WageNet,
                Field37Advantages:Field37Advantages,
                Field37AdvantangeCheckbox:Field37AdvantangeCheckbox,
                Field3701AdvantagesDetail:Field3701AdvantagesDetail
            }
            //let stringInfo = JSON.stringify(jobPartnerEmployee)
            let stringInfo = serialize(jobPartnerEmployee, {isJSON: true});
            localStorage.setItem("jobPartnerEmployee" , stringInfo)
            //console.log(JSON.parse(stringInfo))
            next()
        }

    }

    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={4}/>
                    <Row>
                        <Col>
                            <h3>{d?  i18n.t('MariedJOBTITLEDEATH') : i18n.t('JOBTITLE') }</h3>
                             <h4 className={"text-primary"}>{  i18n.t("MariedLe défunt était salarié")  }</h4>
                            <Alert color="warning">
                                <span className="glyphicon glyphicon-record"/>
                                <strong>{i18n.t("Attention")}</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t("joindre preuve revenu")}</p>
                            </Alert>
                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <h4>{ i18n.t("MariedDonnées de l'employeur")}</h4>
                                    <FormGroup>
                                        <Label for="Field32Name">{i18n.t("field32Name")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} {...bindField32Name} placeholder={d? i18n.t("Mariedplaceholderfield32NameDeath") : i18n.t("placeholderfield32Name")} invalid={(NotValid && Field32Name === "true")? true : undefined}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <div>
                                        <Label for="Field33Address">{i18n.t("ADDRESSDATA")}</Label>
                                        <FormGroup className="row py-0">
                                            <Label for="Field33AddressStreet" className={"col-sm-2"} invalid={(NotValid && Field33AddressStreetError === "true")? true : undefined}>{i18n.t("field33AddressStreet")} <span className={"text-danger"}>*</span></Label>

                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField33AddressStreet} placeholder={i18n.t("field33AddressStreet")} invalid={(NotValid && Field33AddressStreet === "true")? true : undefined}/>

                                        </FormGroup>
                                        <FormGroup className="row py-0">
                                            <Label for="Field33AddressStreetNumber" className={"col-sm-2"} invalid={(NotValid && Field33AddressStreetNumberError === "true")? true : undefined}>{i18n.t("field33AddressStreetNumber")} <span className={"text-danger"}>*</span></Label>

                                            <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField33AddressStreetNumber} placeholder={i18n.t("field33AddressStreetNumber")} invalid={(NotValid && Field33AddressStreetNumber === "true")? true : undefined}/>

                                            <Label  for="Field33AddressStreetBox" className={"col-sm-2"} invalid={(NotValid && Field33AddressStreetBoxError === "true")? true : undefined}>{i18n.t("field33AddressStreetBox")}</Label>

                                            <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField33AddressStreetBox} placeholder={i18n.t("field33AddressStreetBox")} invalid={(NotValid && Field33AddressStreetBox === "true")? true : undefined}/>

                                        </FormGroup>
                                        <FormGroup className="row py-0">
                                            <Label for="Field33AddressZip" className={"col-sm-2"}  invalid={(NotValid && Field33AddressZipError === "true")? true : undefined}>{i18n.t("field33AddressZip")} <span className={"text-danger"}>*</span></Label>

                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField33AddressZip} placeholder={i18n.t("field33AddressZip")} invalid={(NotValid && Field33AddressZip === "true")? true : undefined}/>

                                        </FormGroup>
                                        <FormGroup className="row  py-0">
                                            <Label for="Field33AddressTown" className={"col-sm-2"} invalid={(NotValid && Field33AddressTownError === "true")? true : undefined}>{i18n.t("field33AddressTown")} <span className={"text-danger"}>*</span></Label>

                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField33AddressTown} placeholder={i18n.t("field33AddressTown")} invalid={(NotValid && Field33AddressTown === "true")? true : undefined}/>

                                        </FormGroup>
                                        {Field33AddressError === "true" && <span className="help-block form-error">{i18n.t("Obligatoires")}</span>}
                                    </div>
                                    <h4>{d? i18n.t("MariedRégime de travail"): i18n.t("Votre régime de travail")}</h4>
                                    <FormGroup>
                                        <Label for="Field34Regime" className={(NotValid && Field34Regime === "") ? "text-danger" : "text"}>{d? i18n.t("field34Regime") : i18n.t("field34Regime")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField34Regime} name="Field34Regime" value="tempsplein" checked={Field34Regime === "tempsplein"}/>
                                                &nbsp;{i18n.t("tempsplein")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField34Regime}  name="Field34Regime" value="tempspartiel" checked={Field34Regime === "tempspartiel"}/>
                                                &nbsp;{i18n.t("tempspartiel")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    {Field34Regime === "tempspartiel" &&
                                    <div className="formlevel02">
                                        <FormGroup>
                                            <Label for="Field34RegimeTempsPartielStatut" className={(NotValid && Field34Regime === "") ? "text-danger" : "text"}>{d? i18n.t("field34RegimeTempsPartielStatut") : i18n.t("field34RegimeTempsPartielStatut")} <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" onChange={handleChangeField34RegimeTempsPartielStatut} name="Field34RegimeTempsPartielStatut" value="contractuel" checked={Field34RegimeTempsPartielStatut === "contractuel"}/>
                                                    &nbsp;{i18n.t("contractuel")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio"  onChange={handleChangeField34RegimeTempsPartielStatut}  name="Field34RegimeTempsPartielStatut" value="reduction" checked={Field34RegimeTempsPartielStatut === "reduction"}/>
                                                    &nbsp;{i18n.t("reduction")}
                                                </Label>
                                            </div>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Field34RegimeTempsPartielType" className={(NotValid && Field34Regime === "") ? "text-danger" : "text"}>{d? i18n.t("field34RegimeTempsPartielType") : i18n.t("field34RegimeTempsPartielType")} <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" onChange={handleChangeField34RegimeTempsPartielType} name="Field34RegimeTempsPartielType" value="cinquieme" checked={Field34RegimeTempsPartielType === "cinquieme"}/>
                                                    &nbsp;{i18n.t("cinquieme")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio"  onChange={handleChangeField34RegimeTempsPartielType}  name="Field34RegimeTempsPartielType" value="mitemps" checked={Field34RegimeTempsPartielType === "mitemps"}/>
                                                    &nbsp;{i18n.t("mitemps")}
                                                </Label>
                                            </div>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name={"field34RegimeTempsPartielType"} value="autre" onChange={handleChangeField34RegimeTempsPartielType} checked={(Field34RegimeTempsPartielType === "autre")} />
                                                    &nbsp;{i18n.t("autre")} <span className={"text-danger"}>*</span>
                                                </Label>
                                            </div>
                                            {Field34RegimeTempsPartielType === "autre" &&
                                            <div className={"formlevel03"}>
                                                <FormGroup className={(NotValid && Field34RegimeTempsPartielTypeDetail === "") ? "text-danger" : "text"}>
                                                    <Input type="text"
                                                           name="cohabitantDetail" placeholder={i18n.t("placeholderField34RegimeTempsPartielTypeDetail")}
                                                           {...bindField34RegimeTempsPartielTypeDetail} invalid={(NotValid && Field34RegimeTempsPartielTypeDetail === "")} />
                                                    {(NotValid && !Field34RegimeTempsPartielTypeDetail) &&<span className="help-block form-error">{i18n.t("Obligatoire")}</span>}
                                                </FormGroup>
                                            </div>
                                            }
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>
                                    </div>}
                                    <FormGroup>
                                        <Label for="Field35Hours">{i18n.t("MariedNombre d’heures qui étaient prestées par semaine") } <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} {...bindField35Hours} placeholder={i18n.t("Mariedplaceholderfield35Hours")} invalid={(NotValid && Field35Hours === "true")? true : undefined}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="Field36Wage" className={(NotValid && Field36Wage === "") ? "text-danger" : "text"}>{d? i18n.t("MariedLe salaire du défunt") : i18n.t("Votre salaire actuel")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField36Wage} name="Field36Wage" value="heure" checked={Field36Wage === "heure"}/>
                                                &nbsp;{i18n.t("heure")}
                                            </Label>
                                        </div>
                                        { Field36Wage === "heure" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field3601WageBrut")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field3601WageBrut"} {...bindField3601WageBrut} placeholder={i18n.t("Mariedplaceholderfield3601WageBrut")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3602WageImposable")}  <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3602WageImposable} placeholder={i18n.t("Mariedplaceholderfield3602WageImposable")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3603WageNet")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3603WageNet} placeholder={i18n.t("Mariedplaceholderfield3603WageNet")} />
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field3603WageNet && !Field3601WageBrut && !Field3602WageImposable && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField36Wage}  name="Field36Wage" value="mensuel" checked={Field36Wage === "mensuel"}/>
                                                &nbsp;{i18n.t("mensuel")}
                                            </Label>
                                        </div>
                                        { Field36Wage === "mensuel" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field3601WageBrut")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field3601WageBrut"} {...bindField3601WageBrut} placeholder={i18n.t("Mariedplaceholderfield3601WageBrut")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3602WageImposable")}  <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3602WageImposable} placeholder={i18n.t("Mariedplaceholderfield3602WageImposable")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3603WageNet")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3603WageNet} placeholder={i18n.t("Mariedplaceholderfield3603WageNet")} />
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field3603WageNet && !Field3601WageBrut && !Field3602WageImposable && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField36Wage}  name="Field36Wage" value="annuel" checked={Field36Wage === "annuel"}/>
                                                &nbsp;{i18n.t("annuel")}
                                            </Label>
                                        </div>
                                        { Field36Wage === "annuel" &&
                                        <div className={"formlevel02"}>
                                            <FormGroup>
                                                <Label>{i18n.t("field3601WageBrut")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} name={"Field3601WageBrut"} {...bindField3601WageBrut} placeholder={i18n.t("Mariedplaceholderfield3601WageBrut")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3602WageImposable")}  <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3602WageImposable} placeholder={i18n.t("Mariedplaceholderfield3602WageImposable")} />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{i18n.t("field3603WageNet")} <span className={"text-warning"}>*</span></Label>
                                                <InputGroup>
                                                    <div className={"input-group-prepend"}>
                                                        <FontAwesomeIcon className="pre" icon={['fas', 'euro']} />
                                                    </div>
                                                    <Input type={"text"} {...bindField3603WageNet} placeholder={i18n.t("Mariedplaceholderfield3603WageNet")} />
                                                </InputGroup>
                                            </FormGroup>
                                            {!Field3603WageNet && !Field3601WageBrut && !Field3602WageImposable && NotValid && <span className={"help-block text-danger"}>{i18n.t("Obligatoire")}</span>}

                                        </div>
                                        }
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="Field37Advantages" className={(NotValid && Field37Advantages === "") ? "text-danger" : "text"}>{ i18n.t("Mariedfield37Advantages")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField37Advantages}  name="Field37Advantages" value="no" checked={Field37Advantages === "no"}/>
                                                &nbsp;{i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField37Advantages} name="Field37Advantages" value="yes" checked={Field37Advantages === "yes"}/>
                                                &nbsp;{i18n.t("YES")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    {Field37Advantages === "yes" &&
                                    <div className={"formlevel02"}>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="cheque" onChange={handleChangeField37AdvantangeCheckbox} value="cheque"  checked={!!Field37AdvantangeCheckbox.cheque ? Field37AdvantangeCheckbox.independant : '' } />
                                                {  i18n.t("field37AdvantagesCheque") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="groupe" onChange={handleChangeField37AdvantangeCheckbox} value="groupe"  checked={!!Field37AdvantangeCheckbox.groupe ? Field37AdvantangeCheckbox.hospi : '' } />
                                                {  i18n.t("field37AdvantagesGroupe") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="hospi" onChange={handleChangeField37AdvantangeCheckbox} value="hospi"  checked={!!Field37AdvantangeCheckbox.hospi ? Field37AdvantangeCheckbox.hospi : '' } />
                                                {  i18n.t("field37AdvantagesHospi") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="revgar" onChange={handleChangeField37AdvantangeCheckbox} value="revgar"  checked={!!Field37AdvantangeCheckbox.revgar ? Field37AdvantangeCheckbox.revgar : '' } />
                                                {  i18n.t("field37AdvantagesRevGar") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="voiture" onChange={handleChangeField37AdvantangeCheckbox} value="voiture"  checked={!!Field37AdvantangeCheckbox.voiture ? Field37AdvantangeCheckbox.voiture : '' } />
                                                {  i18n.t("field37AdvantagesVoiture") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="transpcomm" onChange={handleChangeField37AdvantangeCheckbox} value="transpcomm"  checked={!!Field37AdvantangeCheckbox.transpcomm ? Field37AdvantangeCheckbox.transpcomm : '' } />
                                                {  i18n.t("field37AdvantagesTranspComm") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="velo" onChange={handleChangeField37AdvantangeCheckbox} value="velo"  checked={!!Field37AdvantangeCheckbox.velo ? Field37AdvantangeCheckbox.velo : '' } />
                                                {  i18n.t("field37AdvantagesVelo") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="rembfrais" onChange={handleChangeField37AdvantangeCheckbox} value="rembfrais"  checked={!!Field37AdvantangeCheckbox.rembfrais ? Field37AdvantangeCheckbox.rembfrais : '' } />
                                                {  i18n.t("field37AdvantagesRembFrais") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="primefinannee" onChange={handleChangeField37AdvantangeCheckbox} value="primefinannee"  checked={!!Field37AdvantangeCheckbox.primefinannee ? Field37AdvantangeCheckbox.primefinannee : '' } />
                                                {  i18n.t("field37AdvantagesPrimeFinAnnee") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="bonusprestation" onChange={handleChangeField37AdvantangeCheckbox} value="bonusprestation"  checked={!!Field37AdvantangeCheckbox.bonusprestation ? Field37AdvantangeCheckbox.bonusprestation : '' } />
                                                {  i18n.t("field37AdvantagesBonusPrestation") }
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="checkbox" name="other" onChange={handleChangeField37AdvantangeCheckbox} value="other"  checked={!!Field37AdvantangeCheckbox.other ? Field37AdvantangeCheckbox.other : '' } />
                                                {  i18n.t("field37AdvantagesOther") }
                                            </Label>
                                        </div>
                                        {Field37AdvantangeCheckbox.other &&
                                        <div>
                                            <FormGroup className={(NotValid && Field3701AdvantagesDetail === "") ? "text-danger" : "text"}>
                                                <Label for="Field3701AdvantagesDetail">{d? i18n.t("Mariedfield3701AdvantagesDetail") : i18n.t("field3701AdvantagesDetail")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="textarea"
                                                       {...bindField3701AdvantagesDetail} placeholder={i18n.t("Mariedplaceholderfield3701AdvantagesDetail")}
                                                         invalid={(NotValid && Field3701AdvantagesDetail === "")} />
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>
                                        }
                                    </div>
                                    }



                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>
                            </Form>

                            <span className={"text-danger"}>* </span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default JobPartnerEmployee

